export default __webpack_public_path__ + "static/media/log-in.9f5a793c.svg";